import { Injectable } from '@angular/core';
import { MedicalFeePaymentService } from './medical-fee-payment.service';
import { MedicalFeePaymentEditInfo } from '../../model/medical-fee/medical-fee-payment-edit-info';
import { MedicalFeeControlSearchItem } from '../../model/medical-fee/medical-fee-control-search-item';
import { MedicalFeeAmount } from '../../model/medical-fee/medical-fee-amount';
import { MedicalFeeService } from './medical-fee.service';
import { MedicalFeeAmountService } from './medical-fee-amount.service';

@Injectable()
export class MedicalFeePaymentWizardService {

  constructor( private mfpService: MedicalFeePaymentService,
               private mfaService: MedicalFeeAmountService,
               private mfService: MedicalFeeService) { }

  medicalFeePaymentEditInfo: MedicalFeePaymentEditInfo;

  async init( medicalPreFeeBillId: number ) {
    this.medicalFeePaymentEditInfo =
      await this.mfpService.getMedicalFeePaymentEditInfo( medicalPreFeeBillId );
  }

  getMedicalFeeAmount() {
    return this.medicalFeePaymentEditInfo.MedicalFeeAmount;
  }

  getMedicalFeeControlSearchItems() {
    return this.medicalFeePaymentEditInfo.MedicalFeeControlSearchItems;
  }

  async removeMedicalFeeControlSearchItems( items: MedicalFeeControlSearchItem[] ) {

    items.forEach( ( item ) => {

      const index = this.medicalFeePaymentEditInfo
        .MedicalFeeControlSearchItems
        .findIndex( m => m.ValorizationFeeId === item.ValorizationFeeId);

      if ( index > -1 ) {
        this.medicalFeePaymentEditInfo
        .MedicalFeeControlSearchItems.splice( index, 1 );
      }
    });

    this.medicalFeePaymentEditInfo.RemoveMedicalFeeControlSearchItems.push(...items);
    await this.recalculate( items );

  }

  private async recalculate( removeItems: MedicalFeeControlSearchItem[] ) {

    const medicalFeeAmount = this.getMedicalFeeAmount();

    removeItems.forEach( (item) => {

      const medicalFeePracticeTaxAmount =
          medicalFeeAmount.MedicalFeePracticeTaxAmounts
            .find( m => m.AliquotTax.Id === item.AliquotTax.Id );

      if (  item.MedicalFeeAmount ) {
        medicalFeePracticeTaxAmount.AmountBase -= item.MedicalFeeAmount;
      }

    });

    this.setMedicalFeeAmount(await this.mfaService
      .recalculateMedicaFeeAmounts(medicalFeeAmount));
  }

  setMedicalFeeAmount( medicalFeeAmount: MedicalFeeAmount ) {
    this.medicalFeePaymentEditInfo.MedicalFeeAmount = medicalFeeAmount;
  }

  async createReport() {
     return await this.mfService.createMedicalFeeReport(this.medicalFeePaymentEditInfo);
  }

  async createMedicalFeeBill() {
    await this.mfpService.createMedicalFeeBill( this.medicalFeePaymentEditInfo );
  }

}
